import { h } from "preact";
import { useState, useEffect, } from "preact/hooks";

import {
    Box,

    Popover,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";

import WarningIcon from '@mui/icons-material/Warning';
import NumberFormat from 'react-number-format';

import InfoIcon from '@mui/icons-material/Info';
const NumberFormatCustom = (props) => {
    const { onChange, ...other } = props;
    // ref = useRef()
    return (
        <NumberFormat
            {...other}
            //       getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator={" "}
            format="### ### ###"
            isNumericString

        />
    );
};
export default function SirenField({ id, handleChange, key, value }) {

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">

            <Box >
                <TextField
                    id={id}
                    name={id}
                    key={key}
                    //  style={{ width: 75 }}
                    //placeholder={placeholder}
                    onChange={handleChange}
                    margin="normal"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    variant="outlined"
                    value={value !== 0 ? value : ""}
                    size="small"
                    fullWidth
                    placeholder="SIREN (9 chiffres)"
                    InputProps={
                        { inputComponent: NumberFormatCustom, }
                    }
                />

            </Box>
        </Box>
    );
}
